import { render } from "./iconPercent.vue?vue&type=template&id=b6f72166"
import script from "./iconPercent.vue?vue&type=script&lang=js"
export * from "./iconPercent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__